import React from 'react'
import { Col } from 'react-bootstrap'
import './separator.css'

const Separator = (props) => (
  <Col xs={12} md={10} mdOffset={1}>
    <div className='separator' />
  </Col>
)

export default Separator
